export default __webpack_public_path__ + "static/media/correct.15353ac0.wav";